// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_je-0";
export var fileCarousel = "_je-2";
export var removeFileButton = "_je-1";